// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"14fe9fb2","277":"5fb86cb2","297":"33518c76","453":"056f178f","714":"eaf5c25b","756":"0229f609","870":"c59559d9"}[chunkId] + ".chunk.js";
};